import { observable, makeObservable } from 'mobx'
import * as R from 'ramda'
import i18n from 'i18next'

export default class QListQuestion {
    @observable isMandatory = false

    @observable isEditable = false

    @observable notDeletable = false

    @observable isRecommended = false

    @observable isDataImport = false

    @observable isAiCodingDisabled = false

    @observable allowQuadrantAnalysis = false

    @observable parentId

    @observable isAI

    @observable mapping

    constructor(question) {
        makeObservable(this)
        this.isMandatory = Boolean(question.mandatory)
        this.isEditable = Boolean(question.isEditable) || Boolean(question.iseditable)
        this.name = question.title || ''
        this.deletable = true
        this.modifiable = true
        this.isRecommended = Boolean(question.isRecommended)
        this.isDataImport = Boolean(question.isDataImport)
        this.isAiCodingDisabled = Boolean(question.isAiCodingDisabled)
        this.allowQuadrantAnalysis = Boolean(question.allowQuadrantAnalysis)
        this.title = question.title
        this.clientId = question.clientId
        this.kpiType = question.kpiType
        this.qlistId = question.qListId
        this.questionId = question.questionId
        this.qlistoid = question.qlistoid
        this.recommended = question.qlistrecommended
        this.oid = question.questionoid
        this.questionType = question.questionType || question.questiontype
        this.parentId = question.parentId
        this.locales = question.locales
        this.isAI = question.isAI
        this.mapping = question.mapping
        this.questionType = question.questionType
    }

    isInheritValid = (store) => (
        store.isInheritValid(this.parentId, this.questionId)
    )

    setParentId = async (newParentId) => {
        if (!this.modifiable || this.viewOnly) {
            return
        }
        const oldParentId = this.parentId
        this.parentId = newParentId
        const body = JSON.stringify({
            parentId: newParentId,
            qlistId: this.qlistId,
        })
        console.log(`toggleMandatory ${body}`)
        try {
            await this.http.put('/qlist/update', body)
        } catch (e) {
            this.parentId = oldParentId
            console.log(`Error updating qlist: ${e}`)
        }
    }

    toggleMandatory = () => {
        if (!this.modifiable || this.viewOnly) {
            return
        }
        const body = JSON.stringify({
            mandatory: !this.isMandatory ? 1 : 0,
            qlistId: this.qlistId,
        })
        this.http.put('/qlist/update', body)
            .then(() => {
                this.isMandatory = !this.isMandatory
            })
            .catch((e) => {
                console.log(`ERROR!!!!: ${e}`)
            })
    }

    toggleRecommended = () => {
        const body = JSON.stringify({
            isRecommended: !this.isRecommended ? 1 : 0,
            qlistId: this.qlistId,
        })
        this.http.put('/qlist/update', body)
            .then(() => {
                this.isRecommended = !this.isRecommended
            })
            .catch((e) => {
                console.log(`ERROR!!!!: ${e}`)
            })
    }

    toggleIsAiCodingDisabled = () => {
        const body = JSON.stringify({
            isAiCodingDisabled: !this.isAiCodingDisabled ? 1 : 0,
            qlistId: this.qlistId,
        })
        this.http.put('/qlist/update', body)
            .then(() => {
                this.isAiCodingDisabled = !this.isAiCodingDisabled
            })
            .catch((e) => {
                console.log(`ERROR!!!!: ${e}`)
            })
    }

    toggleIsDataImport = () => {
        const body = JSON.stringify({
            isDataImport: !this.isDataImport ? 1 : 0,
            qlistId: this.qlistId,
        })
        this.http.put('/qlist/update', body)
            .then(() => {
                this.isDataImport = !this.isDataImport
            })
            .catch((e) => {
                console.log(`ERROR!!!!: ${e}`)
            })
    }

    toggleEditable = () => {
        if (this.viewOnly) {
            return
        }
        const { store } = this
        store.surveyLocale = 'en_GB'
        store.questionDetails = {
            oid: this.oid,
            productType: this.qlistStore.eventType.value,
            surveyType: 'PE',
            industryType: 'EV',
            categoryId: this.qlistStore.categoryId,
            respondentType: this.qlistStore.respondentType.value,
            portfolioId: this.recordId,
            contextOid: this.contextOid,
            questionId: this.questionId,
            addQuestion: this.qlistStore.addQuestion,
            editQuestion: this.qlistStore.editQuestion,
        }
        store.showQuestionEditor = true
    }

    getQuestionLevel() {
        return this.oid
    }

    findChildQuestion = () => this.qlistStore.questions.find((q) => q.parentId === this.questionId)

    findParentQuestion = () => this.qlistStore.questions.find((q) => q.questionId === this.parentId)

    delete = async () => {
        const childQuestion = this.findChildQuestion()

        if (childQuestion) {
            this.qlistStore.openWarningModal({
                title: i18n.t('qlist_inherited_options'),
                body: i18n.t('qlist_inherited_option_in_child', { child: childQuestion.title }),
            })
            return false
        }

        try {
            await this.http.delete(`/qlist/${this.qlistId}`)
            const arr = this.qlistStore.questions.filter((q) => q.qlistId !== this.qlistId)
            const { kpiType } = this
            if (['BEH', 'COG'].includes(kpiType) && this.qlistStore.sgKpis.indexOf(kpiType) > -1) {
                this.qlistStore.sgKpis.splice(this.qlistStore.sgKpis.indexOf(kpiType), 1)
            }
            this.qlistStore.questions = arr
            this.qlistStore.filterList()
            Reflect.deleteProperty(this, 'qlistStore')
            return true
        } catch (e) {
            console.log(`ERROR!!!!!: ${e}`)
        }
        return false
    }
}
